import { render, staticRenderFns } from "./DepositPaymentOption.vue?vue&type=template&id=72d1061e&scoped=true&"
import script from "./DepositPaymentOption.vue?vue&type=script&lang=ts&"
export * from "./DepositPaymentOption.vue?vue&type=script&lang=ts&"
import style0 from "./DepositPaymentOption.vue?vue&type=style&index=0&id=72d1061e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1061e",
  null
  
)

export default component.exports